
export enum UserContactStatus {
    CREATING = "creating",
    PENDING = "pending",
    ACTIVE = "active",
    DELETED = "deleted",
    BLOCKED = "blocked"
}